import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, normalizeProps as _normalizeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import SvgIcon from "./SvgIcon/SvgIcon.vue";
import type { SpriteSymbol } from "../types/GeneratedSpriteType";


export default /*@__PURE__*/_defineComponent({
  __name: 'SharedButtonOnlyIcon',
  props: {
    iconName: {},
    iconSize: { default: "5" },
    dataTestName: { default: "" }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", _normalizeProps({
    type: "button",
    class: "inline-grid select-none place-content-center whitespace-nowrap rounded-full align-top disabled:text-gray-50",
    [_ctx.dataTestName || ""]: '',
    style: {"-webkit-tap-highlight-color":"transparent"}
  }), [
    _createVNode(SvgIcon, {
      class: _normalizeClass(`size-${_ctx.iconSize}`),
      "icon-name": _ctx.iconName
    }, null, 8, ["class", "icon-name"])
  ], 16))
}
}

})